module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-cell', [_vm._v("申报成功的四好运动员")]), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(subject, index) {
    return _c('div', {
      key: index
    }, [_c('van-divider', [_vm._v("四好运动员信息" + _vm._s(index + 1) + "\n        ")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
      attrs: {
        "readonly": "",
        "input-align": "right",
        "label": "姓名",
        "placeholder": "请输入姓名",
        "rules": [{
          required: true,
          message: '请输入姓名'
        }]
      },
      model: {
        value: (subject.name),
        callback: function($$v) {
          _vm.$set(subject, "name", $$v)
        },
        expression: "subject.name"
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "readonly": "",
        "error-message-align": "right",
        "input-align": "right",
        "label": "身份证",
        "placeholder": "请选择身份证号"
      },
      model: {
        value: (subject.num),
        callback: function($$v) {
          _vm.$set(subject, "num", $$v)
        },
        expression: "subject.num"
      }
    }), _vm._v(" "), _c('van-cell', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'H5',
          query: {
            url: subject.exame_url
          }
        }),
        expression: "{name:'H5' ,query:{ url:subject.exame_url }}"
      }],
      attrs: {
        "title": "在线考试",
        "value": "点击这里前往考试",
        "is-link": ""
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.2rem"
      }
    })], 1)], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-468a08d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetailSihaoApplySuccess.vue
// module id = 2356
// module chunks = 0